
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeadingLineOffProposal as ObiHeadingLineOffProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heading-line-off-proposal.js';
 
 
 

 
 export const ObiHeadingLineOffProposal = createComponent({
   react: React,
   tagName: 'obi-heading-line-off-proposal',
   elementClass: ObiHeadingLineOffProposalElement,
   events: {
     
   }
  });
 
 